'use client';

import React from "react";

export const Section = ({ title, subtitle, children }) => (
  <section className="rounded-xl border border-zinc-200 bg-white p-5">
    <h2 className="text-sm font-semibold text-zinc-900">{title}</h2>
    {subtitle && <p className="mt-0.5 text-xs text-zinc-500">{subtitle}</p>}
    <div className="mt-4 grid gap-4 sm:grid-cols-2">{children}</div>
  </section>
);

export const Field = ({
  label, value, onChange, placeholder, hint, type = "text",
  disabled, testId, transform, inputMode, maxLength, textarea, full,
}) => {
  const handle = (e) => {
    let v = e.target.value;
    if (transform === "upper") v = v.toUpperCase();
    if (transform === "digits") v = v.replace(/\D/g, "");
    if (maxLength) v = v.slice(0, maxLength);
    onChange(v);
  };
  const cls =
    "w-full rounded-md border border-zinc-300 px-3 py-2.5 text-sm outline-none focus:border-zinc-900 disabled:bg-zinc-50 disabled:text-zinc-500";
  return (
    <label className={`block ${full ? "sm:col-span-2" : ""}`}>
      <span className="mb-1 block text-sm font-medium text-zinc-700">{label}</span>
      {textarea ? (
        <textarea data-testid={testId} value={value} onChange={handle} disabled={disabled} placeholder={placeholder} rows={2} className={cls} />
      ) : (
        <input data-testid={testId} value={value} onChange={handle} disabled={disabled} placeholder={placeholder} type={type} inputMode={inputMode} className={cls} />
      )}
      {hint && <span className="mt-1 block text-xs text-zinc-400">{hint}</span>}
    </label>
  );
};
